import { useCurrentStateAndParams } from "@uirouter/react";

import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";
import type { AdvertiserActivityParamKeys } from "single-spa/react-app/config/solutions25/adIntelligence/advertiserActivity/advertiserActivityRoutes.types";

type UseAdvertiserActivityDataAndParamsReturn = Record<
    Exclude<AdvertiserActivityParamKeys, "country" | "webSource">,
    string | undefined
> & {
    country: number;
    webSource: WebSource;
};

export const useAdvertiserActivityDataAndParams = (): UseAdvertiserActivityDataAndParamsReturn => {
    const { params } = useCurrentStateAndParams<UseAdvertiserActivityDataAndParamsReturn>();
    return params;
};
